import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@features/ui';
import { FC } from 'react';
import { UserProfile } from '@src/types/users.ts';
import { platformRadioData } from '@features/admin/packages/packagesData.ts';
import { checkDate } from '@lib/utils.ts';
import { useNavigate } from 'react-router-dom';
import { canAccess } from '@src/utils/auth';
import { UserRolePermission } from '@src/types/settings';
import { useAuthStore } from '@src/stores/authStore';

interface UserHeaderProps {
  onFlag?: () => void;
  user: UserProfile | null;
  onDeactivate?: () => void;
  onAddPackage?: () => void;
  onDelete?: () => void;
}
export const UsersHeader: FC<UserHeaderProps> = ({
  onFlag,
  onDeactivate,
  user,
  onAddPackage,
  onDelete,
}) => {
  const { t } = useTranslation();
  const { auth } = useAuthStore();
  const navigate = useNavigate();

  const userType = platformRadioData.find(
    (item) => item.value === user?.user_type
  )?.label;

  const showDeactivate = checkDate(user?.expire_date);

  return (
    <div
      className={
        'flex lg:flex-row flex-col justify-between lg:items-center items-start mb-4 gap-2'
      }
    >
      <p className={'text-[23px]'}>
        <Trans
          i18nKey={'users.title'}
          values={{
            userId: user?.username,
            userName: `${user?.first_name || user?.last_name ? '(' : ''}${user?.first_name ?? ''} ${user?.last_name ?? ''}${user?.first_name || user?.last_name ? ')' : ''}`,
            accountType: userType ?? '',
          }}
        >
          <button
            className={
              'text-blue cursor-pointer font-normal bg-transparent border-0 p-0 inline'
            }
            type="button"
            onClick={() => navigate(-1)}
          >
            <strong />
          </button>
        </Trans>
      </p>
      <div className={'flex gap-6'}>
        {onAddPackage &&
          canAccess(
            UserRolePermission.ADD_PACKAGE,
            auth?.user?.permissions
          ) && (
            <Button
              className={'bg-[#14CA74] hover:bg-[#14CA74]/90'}
              size={'sm'}
              onClick={onAddPackage}
            >
              ADD PACKAGE
            </Button>
          )}
        {onFlag &&
          canAccess(
            UserRolePermission.FLAG_TRADER,
            auth?.user?.permissions
          ) && (
            <Button size={'sm'} variant={'yellow'} onClick={onFlag}>
              {`${user?.is_watched ? 'Un-flag User' : 'Flag User'}`}
            </Button>
          )}
        {showDeactivate &&
          canAccess(
            UserRolePermission.DISABLE_TRADER,
            auth?.user?.permissions
          ) && (
            <Button
              className={'bg-[#C13839]'}
              size={'sm'}
              onClick={onDeactivate}
            >
              {t('users.button.deactivate')}
            </Button>
          )}
        {onDelete &&
          canAccess(
            UserRolePermission.DELETE_TRADER,
            auth?.user?.permissions
          ) && (
            <Button className={'bg-[#C13839]'} size={'sm'} onClick={onDelete}>
              {t('users.button.delete')}
            </Button>
          )}
      </div>
    </div>
  );
};
